import { Box, Stack, Typography } from "@mui/material";

const ExecutiveSummaryBar = () => {
  const data = {
    delivered: {
      orders: 124,
      no_of_customers: 12,
      order_amount: 122325,
    },
    worstPerformance: {
      orders: 23,
      no_of_customers: 5,
      order_amount: 1324,
      growth: "-42%",
    },
    bestPerformance: {
      orders: 284,
      no_of_customers: 90,
      order_amount: 1189000,
      growth: "45%",
    },
  };
  return (
    <Stack direction={"row"} gap={2}>
      <Box
        border={"1px solid #D3DBEC"}
        borderRadius={"20px"}
        p={2}
        width={"10vw"}
        bgcolor={"#F3F5F8"}
      >
        <Stack>
          <Typography fontSize={12} fontWeight={550}>
            Delivered
          </Typography>
          <Typography fontSize={24} fontWeight={650}>
            {data.delivered.orders} Orders
          </Typography>
          <Typography fontSize={15} color={"gray"}>
            {data.delivered.no_of_customers} Stockists
          </Typography>
          <Typography fontSize={15} color={"gray"}>
            ₹{data.delivered.order_amount.toLocaleString("en-IN")}
          </Typography>
        </Stack>
      </Box>
      <Box
        border={"0.5px solid #D3DBEC"}
        borderRadius={"20px"}
        p={2}
        width={"10vw"}
        bgcolor={"#FFE9E9"}
      >
        <Stack>
          <Typography color={"#F23B0D"} fontSize={12} fontWeight={550}>
            Worst Performance
          </Typography>
          <Typography fontSize={24} fontWeight={650}>
            {data.worstPerformance.orders} Orders
          </Typography>
          <Stack direction={"row"} gap={2}>
            <Typography fontSize={15} fontWeight={550} color={"#F23B0D"}>
              {data.worstPerformance.growth}
            </Typography>
            <Typography fontSize={15} color={"gray"}>
              {data.worstPerformance.no_of_customers} Stockists
            </Typography>
          </Stack>
          <Typography fontSize={15} color={"gray"}>
            ₹{data.worstPerformance.order_amount.toLocaleString("en-IN")}
          </Typography>
        </Stack>
      </Box>
      <Box
        border={"0.5px solid #D3DBEC"}
        borderRadius={"20px"}
        p={2}
        width={"10vw"}
        bgcolor={"#E8FFF8"}
      >
        <Stack>
          <Typography fontSize={12} color={"#18A87F"}>
            Best Performance
          </Typography>
          <Typography fontSize={24} fontWeight={650}>
            {data.bestPerformance.orders} Orders
          </Typography>
          <Stack direction={"row"} gap={2}>
            <Typography fontSize={15} fontWeight={550} color={"#22CC29"}>
              +{data.bestPerformance.growth}
            </Typography>
            <Typography fontSize={15} color={"gray"}>
              {data.bestPerformance.no_of_customers} Stockists
            </Typography>
          </Stack>
          <Typography fontSize={15} color={"gray"}>
            ₹ {data.bestPerformance.order_amount.toLocaleString("en-IN")}
          </Typography>
        </Stack>
      </Box>
    </Stack>
  );
};

export default ExecutiveSummaryBar;
